import React from "react";
import { Select, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import message from "@/utils/globalMessage";

// Cap shared by the create form and the detail-page edit modal so both surfaces
// enforce the same limit the API applies server-side.
export const CC_EMAILS_MAX = 5;

const TOOLTIP = `Type an email address and press Enter to add it. You can add up to ${CC_EMAILS_MAX} addresses; they will be copied on this contract request's notification emails.`;

// Form.Item label content: the field name plus an info icon explaining that
// Enter commits each address. Kept here so the create form and the edit modal
// read the same wording.
export const renderCcEmailsLabel = (text = "CC email addresses (optional)") => (
  <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
    <span>{text}</span>
    <Tooltip title={TOOLTIP}>
      <InfoCircleOutlined style={{ color: "#8c8c8c" }} />
    </Tooltip>
  </span>
);

/**
 * Tag-style email picker. `open={false}` turns the tags select into a plain
 * free-text input that commits a chip on Enter/comma/semicolon, matching the
 * "Invite contractor" dialog on the Contractor Management page.
 *
 * Also enforces {@link CC_EMAILS_MAX} at input time: extra chips are dropped
 * with a warning, so the value never exceeds the server-side limit.
 */
export default function ContractCcEmailsSelect({ value, onChange, style, ...rest }) {
  return (
    <Select
      {...rest}
      style={{ width: "100%", ...style }}
      mode="tags"
      open={false}
      suffixIcon={null}
      tokenSeparators={[",", " ", ";"]}
      placeholder="Type an email and press Enter"
      options={[]}
      value={value}
      onChange={(values) => {
        const list = Array.isArray(values) ? values : [];
        if (list.length > CC_EMAILS_MAX) {
          message.warning(`You can add up to ${CC_EMAILS_MAX} CC email addresses`);
          onChange?.(list.slice(0, CC_EMAILS_MAX));
          return;
        }
        onChange?.(values);
      }}
    />
  );
}
